import { render, staticRenderFns } from "./pickSvg.vue?vue&type=template&id=53a00767&"
import script from "./pickSvg.vue?vue&type=script&lang=js&"
export * from "./pickSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports